import { useState, type ChangeEvent } from 'react';
import { FolderOpen } from 'lucide-react';
import type { Proyecto } from '../../types';

interface Props {
  editando: Proyecto | null;
  onGuardar: (nombre: string) => void;
  onCancelar: () => void;
}

export function FormularioProyecto({ editando, onGuardar, onCancelar }: Props) {
  const [nombre, setNombre] = useState(editando?.nombre ?? '');

  const guardar = () => {
    if (!nombre.trim()) {
      alert('Por favor escribe un nombre');
      return;
    }
    onGuardar(nombre.trim());
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        {editando ? '✏️ Renombrar Proyecto' : 'Nuevo Proyecto'}
      </h2>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <FolderOpen size={16} className="inline mr-1" />
          Nombre *
        </label>
        <input
          type="text"
          value={nombre}
          maxLength={200}
          autoFocus
          onChange={(e: ChangeEvent<HTMLInputElement>) => setNombre(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') guardar();
          }}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
          placeholder="¿Cómo se llama el proyecto?"
        />
      </div>
      <div className="flex gap-3 mt-6">
        <button
          onClick={guardar}
          className="flex-1 bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {editando ? 'Guardar Cambios' : 'Guardar Proyecto'}
        </button>
        <button
          onClick={onCancelar}
          className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
